<template>
  <div>
    <label v-if="schema.personLabel" class="label font-weight-bold">{{ schema.personLabel.$model }}</label>

    <div class="row">
      <w-select class="col" :model="schema.year" :values="getYears" />

      <template v-if="!!schema.month">
        <w-select class="col" :model="schema.month" :values="months" />
      </template>

      <template v-if="documentDate">
        <w-datepicker class="col" :model="schema.documentDate" />
      </template>
    </div>

    <div class="row mt-2">
      <w-datepicker v-if="!!schema.paymentDate" class="col col-md-6" :model="schema.paymentDate" />

      <w-input v-if="!!schema.paymentYear" class="col col-md-6" :model="schema.paymentYear" />

      <w-select v-if="!!schema.paymentMonth" class="col col-md-6" :model="schema.paymentMonth" :values="allMonths" />
    </div>

    <template v-if="isPersonData">
      <div class="row mt-2">
        <w-input class="col-6" :model="schema.firstName" />

        <w-input class="col-6" :model="schema.lastName" />
      </div>

      <div class="row mt-2">
        <w-input class="col-6" :model="schema.phoneNumber" />

        <w-input class="col-6" :model="schema.email" />
      </div>
    </template>

    <template v-if="isReport">
      <hr />

      <label class="label font-weight-bold"> Przyuczenie do wykonywania określonej pracy </label>

      <div class="row">
        <w-input class="col-6" :model="schema.apprenticeship.numberOfEmployees" />

        <w-datepicker class="col-6" :model="schema.apprenticeship.dateOfReturn" />
      </div>

      <div class="row">
        <w-textarea class="col-12" :model="schema.apprenticeship.reasonOfNotUsingFunds" />
      </div>

      <hr />

      <label class="label font-weight-bold"> Nauka zawodu w okresie kształcenia wynoszącym 36 miesięcy </label>

      <div class="row">
        <w-input class="col-6" :model="schema.learningOfProfession.numberOfEmployees" />

        <w-datepicker class="col-6" :model="schema.learningOfProfession.dateOfReturn" />
      </div>

      <div class="row">
        <w-textarea class="col-12" :model="schema.learningOfProfession.reasonOfNotUsingFunds" />
      </div>
    </template>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import { months, getYears } from '@/utils/dates';

// @vuese
// Formularz raportu
// @group ActionData
export default {
  components,
  props: {
    // schema
    schema: { type: Object, required: true }
  },
  data() {
    return {
      getYears: getYears()
    };
  },
  computed: {
    allMonths() {
      return months();
    },
    months() {
      return months(this.schema.year.$model);
    },
    isPersonData() {
      return !!this.schema.firstName && !!this.schema.lastName && !!this.schema.phoneNumber && !!this.schema.email;
    },
    documentDate() {
      return !!this.schema.documentDate;
    },
    isReport() {
      return !!this.schema.apprenticeship && !!this.schema.learningOfProfession;
    }
  },

  watch: {
    months(newValue, oldValue) {
      if (newValue.length < oldValue.length && this.schema.month && this.schema.month.$getData() >= newValue.length) {
        this.schema.month.$setDefault();
      }
    }
  }
};
</script>
